module.exports = __webpack_public_path__ + "img/color_block_12.12ff5859.svg";